import FloatConfigContainer from '../FloatConfigContainer/FloatConfigContainer';
import FloatConfigHeader from '../FloatConfigContainer/FloatConfigHeader/FloatConfigHeader';
import FloatConfigOption from '../FloatConfigContainer/FloatConfigOption/FloatConfigOption';
import { useEffect, useState } from 'react';
import { ConfigOption } from 'services/types';
import useStateStore from 'services/store';

const PLACEMENTS = [
    {
        id: 'inner-collar',
        name: 'Collar',
    },
    {
        id: 'inner-cuff',
        name: 'Cuff',
    },
    {
        id: 'inner-placket',
        name: 'Placket',
    },
    {
        id: 'elbow-patch',
        name: 'Elbow Patch',
    },
];

const InnerFabric = () => {
    const { activeProductData, activeFabric, setInnerFabric } = useStateStore();
    const [currentFabrics, setCurrentFabrics] = useState<ConfigOption[]>([]);

    useEffect(() => {
        fetch('data/inner-fabrics.json')
            .then((response) => response.json())
            .then((data) => {
                setCurrentFabrics(data);
            })
            .catch((error) => {
                console.error('Error fetching fabrics:', error);
            });
    }, []);

    const innerFb = activeProductData?.[activeFabric]?.['inner-fabric'];
    const activePlacement = innerFb.activePlacement;
    const placements = innerFb.innerPlacement;
    return (
        <FloatConfigContainer>
            <FloatConfigHeader />
            <div className="pre-body">
                <div className="placement">
                    <div className="title">PLACEMENT</div>
                    <div className="placement-select">
                        {PLACEMENTS.map((plc) => (
                            <div
                                title={plc.name}
                                onClick={() => setInnerFabric('placement', plc.id)}
                                key={plc.id}
                                className={`item-placement ${
                                    activeProductData[activeFabric]['inner-fabric']
                                        .activePlacement === plc.id
                                        ? 'active'
                                        : ''
                                }`}
                            >
                                <div>{plc.name}</div>
                            </div>
                        ))}
                    </div>
                    <div
                        className={`inform ${
                            activeProductData[activeFabric]['inner-fabric'].activePlacement ===
                                'elbow-patch' &&
                            (!activeProductData[activeFabric].cuff.elbowPatch ||
                                activeProductData[activeFabric].cuff.value.includes('short'))
                                ? 'show'
                                : ''
                        }`}
                    >
                        <img src="images/exclamation.svg" alt="exc-mark" />
                        You have to turn on elbow patch in Cuff/Sleeve Tab
                    </div>
                </div>
                {
                    <div className="elbow-patch">
                        <label htmlFor="elbow-patch">Same as outer fabrics</label>
                        <input
                            onChange={() => setInnerFabric('as-outer-fabric')}
                            checked={
                                activePlacement &&
                                placements &&
                                placements[activePlacement]?.isSameAsOuter
                                    ? true
                                    : false
                            }
                            type="checkbox"
                            id="elbow-patch"
                            className="checkbox"
                        />
                    </div>
                }
            </div>
            <div className="body">
                <div className="list-container">
                    {currentFabrics.map((fab) => (
                        <FloatConfigOption
                            type="inner-fabric"
                            key={fab.id}
                            item={fab}
                            procedure="changeInnerFabric"
                        />
                    ))}
                </div>
            </div>
        </FloatConfigContainer>
    );
};

export default InnerFabric;
